<template>
    <transition appear name="drawer" v-bind="$attrs">
        <div
            v-if="visible"
            data-dialog="true"
            class="fixed h-screen right-0 bottom-0 shadow-search"
            :class="[
                'z-' + zindex,
                {
                    'top-[var(--header-height)] overflow-y-hidden': !settings.is_sourcing_mode
                },
            ]"
        >
            <slot></slot>
        </div>
    </transition>
</template>

<script setup>
import { useUser } from "@/Composables";
const { settings } = useUser();

const props = defineProps({
    component: {
        type: Object,
        required: false,
    },
    visible: {
        type: Boolean,
        required: true,
    },
    zindex: {
        type: Number,
        required: true,
    },
});
</script>

<style scoped>
/* ENTER */
.drawer-enter-active,
.drawer-appear-active {
    transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1);
}
.drawer-enter-from,
.drawer-appear-from {
    transform: translateX(100%);
}
.drawer-enter-to,
.drawer-appear-to {
    transform: translateX(0);
}

/* LEAVE */
.drawer-leave-active {
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.drawer-leave-from {
    transform: translateX(0);
}
.drawer-leave-to {
    transform: translateX(100%);
}
</style>
